module.exports = __webpack_public_path__ + "./fonts/DMSans-Medium.d940ea.woff2";